import * as React from "react";
import {Field, reduxForm, InjectedFormProps} from 'redux-form'
import {AppState} from "../../../store/app_state";
import {Action, Dispatch} from "redux";
import {connect} from "react-redux";
import * as Validator from "../../../../util/validation";

import {OuterURL} from "../../../../config/view_const/outer_url";
import styled from "styled-components";
import FormFieldWrapper from "../../../common/atom/wrapper/form_field_wrapper";
import FormGroupInputConnectRf from "../../../common/molecular/form_group/form_group_input_connect_rf";
import FormGroupCheckboxConnectRf from "../../../common/molecular/form_group/form_group_checkbox_connect_rf";
import SubmitErrorTextWrapper from "../../../common/atom/wrapper/submit_error_text_wrapper";
import ErrorText from "../../../common/atom/text/error_text";
import SubmitButtonWrapper from "../../../common/atom/wrapper/submit_btn_wrapper/submit_btn_wrapper";
import BtnCorporateLarge from "../../../common/atom/btn/btn_corporate_large";
import OuterLink from "../../../common/atom/outer_link";
import {ConstBreakPoint} from "../../../../config/styles_const/styles_const";
import {clientConfig} from "../../../../config/language/ja-JP/domain/model_text";

const validate = (values: any) => {
    const errors: any = {};
    return errors
};

interface IProps extends InjectedFormProps<FormData, {}> {
}

interface IState {
}

export class AuthApplyClientLafoolRegisterForm extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);

        this.state = {};

    };

    public render(): JSX.Element {

        const {
            anyTouched,
            error,
            invalid,
            handleSubmit,
            pristine,
            submitting,
        } = this.props;

        const labelText = (
            <React.Fragment>
                <OuterLink href={`${OuterURL.clientTermURL}`} 
                    target="_blank" rel="noopener">
                    利用規約
                </OuterLink>
                と
                <OuterLink href={`${OuterURL.privacyURL}`}
                    target="_blank" rel="noopener">
                    プライバシーポリシー
                </OuterLink>
                に同意します。
            </React.Fragment>
        );

        return (
            <Wrapper>

                <form
                    name="ApplyClientCreateForm"
                    onSubmit={handleSubmit}>

                    <FormFieldWrapper>
                        <Field
                            label="メールアドレス"
                            placeholder="メールアドレス"
                            name="email"
                            component={FormGroupInputConnectRf}
                            type="text"
                            validate={[Validator.required, Validator.email]}
                            require={true}
                        />
                    </FormFieldWrapper>
                    <FormFieldWrapper>
                        <Field
                            label ={clientConfig.phoneNumber}
                            placeholder="080xxxxxxxx（ハイフンなし）"
                            name="phoneNumber"
                            component={FormGroupInputConnectRf}
                            type="tell"
                            validate={[Validator.required, Validator.phoneNumber]}
                            require={true}
                        />
                    </FormFieldWrapper>
                    <FormFieldWrapper>
                        <Field
                            label ="会社名"
                            placeholder="株式会社Libera"
                            name="companyName"
                            component={FormGroupInputConnectRf}
                            type="text"
                            validate={[Validator.required, Validator.companyName]}
                            require={true}
                        />
                    </FormFieldWrapper>
                    <FormFieldWrapper>
                        <Field
                            label ="企業 WEB URL"
                            placeholder="https://example.com"
                            name="webURL"
                            component={FormGroupInputConnectRf}
                            type="text"
                            validate={[Validator.required, Validator.url]}
                            require={true}
                        />
                    </FormFieldWrapper>
                    <FormFieldWrapper>
                        <Field
                            label={clientConfig.name}
                            placeholder="山田　太郎"
                            name="accountName"
                            component={FormGroupInputConnectRf}
                            type="text"
                            validate={[Validator.clientName, Validator.required]}
                            require={true}
                        />
                    </FormFieldWrapper>
                    <FormFieldWrapper>
                        <Field
                            label ={clientConfig.nameKana}
                            placeholder="やまだ　たろう"
                            name="accountNameKana"
                            component={FormGroupInputConnectRf}
                            type="text"
                            validate={[Validator.clientNameKana, Validator.required]}
                            require={true}
                        />
                    </FormFieldWrapper>
                    <FormFieldWrapper>
                        <Field
                            label ={clientConfig.position}
                            placeholder="役職"
                            name="position"
                            component={FormGroupInputConnectRf}
                            type="text"
                            validate={[Validator.title, Validator.required]}
                            require={true}
                        />
                    </FormFieldWrapper>
                    <FormFieldWrapper>
                        <Field
                            label={labelText}
                            name="privacy"
                            component={FormGroupCheckboxConnectRf}
                            validate={[Validator.privacy]}
                        />
                    </FormFieldWrapper>

                    {error ? <SubmitErrorTextWrapper>
                        <ErrorText>{error}</ErrorText>
                    </SubmitErrorTextWrapper> : (anyTouched && invalid) && <SubmitErrorTextWrapper>
                        <ErrorText>入力を完了してください</ErrorText>
                    </SubmitErrorTextWrapper>}

                    <SubmitButtonWrapper>
                        <BtnCorporateLarge
                            name="ApplyClientCreateForm-submit"
                            type="submit"
                            widthSize="200px"
                            disabled={pristine || submitting || invalid}>登録する</BtnCorporateLarge>
                    </SubmitButtonWrapper>

                </form>
            </Wrapper>
        )
    };

}

const mapStateToProps = (state: AppState) => {
    return {};
};

const mapDispatchToProps = (dispatch: Dispatch<Action>) => {
    return {};
};

export default reduxForm({
        form: 'ApplyClientRegisterForm',
        validate,
    }
)(connect(mapStateToProps, mapDispatchToProps)(AuthApplyClientLafoolRegisterForm));

const Wrapper = styled.div`
    @media screen and (min-width: ${ConstBreakPoint.Default}) {
        width: 400px;
    }
`;


// WEBPACK FOOTER //
// ./src/presentation/component/auth/apply_client_lafool_register/auth_apply_client_lafool_register_form.tsx